import { Component, Input, OnInit } from '@angular/core';
import { TypeAlert } from '@pacifico/types/types-model-components';
import { WarningAlertModal } from '@pacifico/utils/enums';
import { Subject } from 'rxjs';
import { DialogRef } from '../modal-side/models/modal-ref';

@Component({
	selector: 'app-modal-alert',
	templateUrl: './modal-alert.component.html',
	styleUrls: ['./modal-alert.component.scss']
})
export class ModalAlertComponent implements OnInit {
	@Input() type: TypeAlert = 'warn';
	@Input() message = '';
	@Input() title = '';
	@Input() showButtonCancel = true;
	@Input() autoClose = false;
	@Input() showButtonClose = true;
	@Input() textFirstButton = 'ACEPTAR';
	@Input() textSecondButton = 'CANCELAR';
	constructor(private dialogRef: DialogRef) {}

	ngOnInit(): void {
		window.scroll(0, 0);
		document.getElementsByTagName('body')[0].classList.add('mostrar_detalle');
		if (this.autoClose) {
			setTimeout(() => {
				this.close();
			}, 3000);
		}
	}

	private readonly _onClose = new Subject<unknown>();
	public onClose = this._onClose.asObservable();

	clickAcept(): void {
		document.getElementsByTagName('body')[0].classList.remove('mostrar_detalle');
		this.dialogRef.close(WarningAlertModal.ACCEPT);
	}

	clickCancel(): void {
		document.getElementsByTagName('body')[0].classList.remove('mostrar_detalle');
		this.dialogRef.close(WarningAlertModal.CANCEL);
	}

	getPathImageAlert(): string {
		let nameImageAlert = 'icon_advertencia.png';

		if (this.type === 'info') {
			nameImageAlert = 'icon_informacion.png';
		} else if (this.type === 'succes') {
			nameImageAlert = 'icon_exito.png';
		} else if (this.type === 'error') {
			nameImageAlert = 'icon_error.png';
		}
		return `assets/images/modal-alert/${nameImageAlert}`;
	}

	getClassType(): string {
		switch (this.type) {
			case 'info':
				return 'modal_info';
			case 'error':
				return 'modal_error';
			case 'succes':
				return 'modal_exito';
			default:
				return 'modal_advertencia';
		}
	}

	close(): void {
		document.getElementsByTagName('body')[0].classList.remove('mostrar_detalle');
		this._onClose.next();
	}

	overlayClicked(): void {
		document.getElementsByTagName('body')[0].classList.remove('mostrar_detalle');
		this.dialogRef.close();
	}
}
